export const isCordova = (): boolean => {
  return !!(window as any).cordova
}